import styled from 'styled-components';
import {getColorFromTheme} from '../../../../../../ui/ui-utils';
import {Typography} from '../../../../../../ui/atoms/typography';
import {
  Dialog,
  DialogBody,
  DialogFooter,
} from '../admin-member/member-redesign.styles';

export const PageWrapper = styled.div`
  border: solid 1px ${getColorFromTheme('borderLight')};
  border-radius: 10px;
}`;

export const FirstWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  > span {
    display: flex;
    align-items: center;
  }
`;

export const PrimaryWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px 0px;
  > span {
    display: flex;
    align-items: center;
  }
`;

export const SecondWrapper = styled.div`
  border: solid 1px ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  .searchBox {
    padding: 12px 16px 16px 16px;
    border-radius: 10px;
  }
  .groupsCount {
    padding: 16px;
    border-top: solid 1px ${getColorFromTheme('borderLight')};
    border-radius: 10px;
  }
  .table-container {
    overflow-x: scroll;
    &::-webkit-scrollbar {
      width: 2em;
      border-top: 1px solid ${getColorFromTheme('borderLight')};
      height: 2.1em;
    }
  }
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 55% 14% 14% 14%;
  background: ${getColorFromTheme('backgroundLight')};
  border-top: 1px solid ${getColorFromTheme('borderLight')};

  grid-gap: 3%;
  padding: 16px;
  height: 52px;
  @media (max-width: 768px) {
    min-width: 500px;
  }
`;

export const TableHeaderChild = styled.div`
  display: grid;
  grid-template-columns: 55% 14% 14% 8%;
  grid-gap: 3%;
  padding: 12px 16px 16px 16px;
  border-top: 1px solid ${getColorFromTheme('borderLight')};
  height: 52px;
  @media (max-width: 768px) {
    min-width: 500px;
  }
  p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  > p {
    display: flex;
    align-items: center;
  }
  > p > svg {
    width: 10.5px;
    height: 14px;
    margin: 7.4px 9px 7.4px 0;
  }
  button > svg:hover,
  svg:active {
    stroke: ${getColorFromTheme('purple300')};
  }
`;

export const DropdownItem = styled.button`
  ${Typography};
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  cursor: pointer;
  border: none;
  background: none;
  display: block;
  outline: none;
  line-height: 1.7;
  padding: 6px 16px;
  transition: all ease-in-out 200ms;
  color: ${getColorFromTheme('textBody')};
  &:hover {
    background-color: ${getColorFromTheme('backgroundDark')};
    color: ${getColorFromTheme('textDark')};
  }
`;

export const ModalWrapper = styled.div`
  max-width: 600px;
  margin: auto;
  @media (max-width: 500px) {
    margin: 0 20px;
  }
`;

export const ModalCard = styled.div`
  background: ${getColorFromTheme('white')};
  padding: 80px;
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  @media (max-width: 500px) {
    padding: 40px;
  }
`;

export const CreateGroupDialog = styled(Dialog)`
  width: min(640px, calc(100vw - 32px));
  overflow: visible;

  form {
    display: flex;
    min-height: 0;
    flex-direction: column;
    border-radius: 12px;
  }
`;

export const CreateGroupHeading = styled.div`
  min-width: 0;
`;

export const CreateGroupTitle = styled.h2`
  margin: 0;
  color: ${getColorFromTheme('blackTwo')};
  font: 600 24px/32px Graphik, sans-serif;
`;

export const CreateGroupSubtitle = styled.p`
  margin: 4px 0 0;
  color: ${getColorFromTheme('textBody')};
  font: 400 16px/24px Graphik, sans-serif;
`;

export const CreateGroupBody = styled(DialogBody)`
  display: grid;
  gap: 16px;
  padding: 24px;
  overflow: visible;

  @media (max-height: 640px) {
    max-height: calc(100vh - 190px);
    overflow-y: auto;
    overflow-x: hidden;
  }
`;

export const CreateGroupFooter = styled(DialogFooter)`
  border-radius: 0 0 12px 12px;
`;

export const CreateGroupField = styled.div`
  position: relative;
  z-index: 2;
  min-width: 0;

  > div {
    margin-bottom: 0;
  }

  &:focus-within {
    z-index: 12;
  }
`;

export const CreateGroupTypeWrapper = styled.div`
  position: relative;
  z-index: 2;
  min-width: 0;

  &:focus-within {
    z-index: 12;
  }
`;

export const CreateGroupTypeLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  color: ${getColorFromTheme('blackTwo')};
  font: 600 14px/22px Graphik, sans-serif;
`;

export const CreateGroupTypeButton = styled.button<{
  $error?: boolean;
  $placeholder?: boolean;
}>`
  display: flex;
  width: 100%;
  min-height: 52px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 13px 16px;
  border: 1px solid
    ${({$error}) =>
      $error ? getColorFromTheme('red300') : getColorFromTheme('borderDark')};
  border-radius: 10px;
  background: ${getColorFromTheme('white')};
  color: ${({$placeholder}) =>
    $placeholder
      ? getColorFromTheme('textBody')
      : getColorFromTheme('blackTwo')};
  font: 400 16px/24px Graphik, sans-serif;
  text-align: left;

  svg {
    flex: 0 0 auto;
    stroke: ${getColorFromTheme('textBody')};
    transition: transform 160ms ease;
  }

  &:focus-visible {
    border-color: ${getColorFromTheme('purple300')};
    outline: 3px solid rgba(88, 90, 223, 0.12);
  }
`;

export const CreateGroupTypeError = styled.p`
  margin: 6px 0 0;
  color: ${getColorFromTheme('red300')};
  font: 400 12px/18px Graphik, sans-serif;
`;

export const CreateGroupTypeDropdown = styled.div`
  position: absolute;
  z-index: 20;
  top: calc(100% + 8px);
  left: 0;
  display: flex;
  width: 100%;
  max-height: min(300px, calc(100vh - 280px));
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  overflow: hidden;
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 8px;
  background: ${getColorFromTheme('white')};
  box-shadow: 0 8px 24px rgba(30, 30, 47, 0.12);
`;

export const CreateGroupTypeSearch = styled.div`
  position: relative;
  flex: 0 0 auto;

  input {
    width: 100%;
    min-height: 40px;
    padding: 8px 40px 8px 12px;
    border: 1px solid ${getColorFromTheme('borderLight')};
    border-radius: 8px;
    outline: 0;
    background: ${getColorFromTheme('white')};
    color: ${getColorFromTheme('blackTwo')};
    font: 400 14px/22px Graphik, sans-serif;

    &::placeholder {
      color: ${getColorFromTheme('textBody')};
    }

    &:focus {
      border-color: ${getColorFromTheme('purple300')};
      box-shadow: 0 0 0 3px rgba(88, 90, 223, 0.12);
    }
  }
`;

export const CreateGroupTypeSearchIcon = styled.span`
  position: absolute;
  top: 50%;
  right: 12px;
  display: inline-flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);
  pointer-events: none;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const CreateGroupTypeList = styled.div`
  display: grid;
  min-height: 0;
  gap: 4px;
  overflow-y: auto;
  overscroll-behavior: contain;
`;

export const CreateGroupTypeOptionButton = styled.button<{
  $selected?: boolean;
}>`
  width: 100%;
  padding: 11px 12px;
  border: 0;
  border-radius: 8px;
  background: ${({$selected}) =>
    $selected
      ? getColorFromTheme('backgroundDark')
      : getColorFromTheme('white')};
  color: ${({$selected}) =>
    $selected ? getColorFromTheme('blackTwo') : getColorFromTheme('textBody')};
  font: ${({$selected}) => ($selected ? 600 : 400)} 14px/22px Graphik,
    sans-serif;
  text-align: left;

  &:hover,
  &:focus-visible {
    background: ${getColorFromTheme('backgroundDark')};
    color: ${getColorFromTheme('blackTwo')};
    outline: none;
  }
`;

export const CreateGroupCustomAction = styled.button`
  display: flex;
  width: 100%;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 0;
  border-top: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 0 0 8px 8px;
  background: ${getColorFromTheme('white')};
  color: ${getColorFromTheme('blackTwo')};
  font: 600 14px/22px Graphik, sans-serif;
  text-align: left;

  &:hover,
  &:focus-visible {
    background: ${getColorFromTheme('backgroundDark')};
    outline: none;
  }
`;

export const CreateGroupCustomIcon = styled.span`
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${getColorFromTheme('green300')};

  svg {
    width: 12px;
    height: 12px;
    stroke: ${getColorFromTheme('alwaysWhite')};
  }
`;

export const ConfirmationStrong = styled.strong`
  color: ${getColorFromTheme('blackTwo')};
`;

export const LoaderWrapper = styled.div`
  padding: 16px;
  border-top: 1px solid ${getColorFromTheme('borderLight')};
`;
